/*
 * Compra rápida por tamanho nos cards de produto.
 * Adiciona via /cart/add.js e reaproveita o carrinho existente (window.MCart, em cart.js)
 * para atualizar e abrir o drawer. Não altera o comportamento de cart.js.
 */
(function () {
  var live = null;

  function announce(message) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('role', 'status');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 60);
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setStatus(card, message) {
    var status = card && card.querySelector('[data-quick-add-status]');
    if (!status) return;
    status.textContent = message || '';
    status.hidden = !message;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quick-add]');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;
    event.preventDefault();

    var card = button.closest('[data-product-card]');
    var label = button.getAttribute('data-quick-add-label') || 'Produto';
    setStatus(card, '');
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.getAttribute('data-quick-add')), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.data.description || result.data.message || 'Não foi possível adicionar este tamanho.');
        }
        button.classList.add('is-added');
        window.setTimeout(function () { button.classList.remove('is-added'); }, 1600);
        announce(label + ' adicionado ao carrinho');
        try {
          document.dispatchEvent(new CustomEvent('realdrip:cart:added', {
            detail: { source: 'quick-add', label: label, button: button, card: card }
          }));
        } catch (e) {}

        if (window.MCart && typeof window.MCart.fetchCart === 'function') {
          return window.MCart.fetchCart().then(function () {
            if (typeof window.MCart.open === 'function') window.MCart.open();
          });
        }
        window.location.href = cartRoot() + 'cart';
      })
      .catch(function (error) {
        var message = (error && error.message) || 'Não foi possível adicionar este tamanho.';
        setStatus(card, message);
        announce(message);
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  });
})();
